import { FC } from "react";
import styled from "styled-components";

import Text from "@/components/Text";

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray};
  ${Text} {
    color: ${({ theme }) => theme.colors.gray};
    transition: color ease-out 0.2s;
  }
  svg {
    margin-right: 8px;
    transform: translateY(-1px);
  }
  &:hover {
    ${Text} {
      color: ${({ theme }) => theme.colors.black};
    }
  }
`;

interface Props {
  text: string;
  icon?: "location" | "date";
  onClick?: () => void;
}

const TableButton: FC<Props> = ({ text, icon, onClick }) => {
  const renderIcon = () => {
    switch (icon) {
      case "location":
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 8.5C9.10457 8.5 10 7.60457 10 6.5C10 5.39543 9.10457 4.5 8 4.5C6.89543 4.5 6 5.39543 6 6.5C6 7.60457 6.89543 8.5 8 8.5Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 6.5C13 11 8 14.5 8 14.5C8 14.5 3 11 3 6.5C3 5.17392 3.52678 3.90215 4.46447 2.96447C5.40215 2.02678 6.67392 1.5 8 1.5C9.32608 1.5 10.5979 2.02678 11.5355 2.96447C12.4732 3.90215 13 5.17392 13 6.5V6.5Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "date":
        return (
          <svg
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.2697 2.28516H1.73122C1.41259 2.28516 1.1543 2.54099 1.1543 2.85658V14.2852C1.1543 14.6007 1.41259 14.8566 1.73122 14.8566H13.2697C13.5883 14.8566 13.8466 14.6007 13.8466 14.2852V2.85658C13.8466 2.54099 13.5883 2.28516 13.2697 2.28516Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.9609 1.14062V3.42634"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.03906 1.14062V3.42634"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.1543 5.71484H13.8466"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      default:
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="15"
              height="15"
              rx="3.5"
              fill="white"
            />
            <path
              d="M5 8H11"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 5L8 11"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              x="0.5"
              y="0.5"
              width="15"
              height="15"
              rx="3.5"
              stroke="#F2F3F7"
            />
          </svg>
        );
    }
  };

  return (
    <Button onClick={onClick}>
      {renderIcon()}
      <Text $type="smallBold">{text}</Text>
    </Button>
  );
};

export default TableButton;
